var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPicture = function SvgPicture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.858 15.37h14.784c1.469 0 2.233-.78 2.233-2.224V2.91c0-1.445-.764-2.233-2.233-2.233H2.858C1.388.678.617 1.442.617 2.91v10.235c0 1.46.772 2.224 2.24 2.224M1.23 2.944c0-1.087.564-1.652 1.644-1.652h14.742c1.046 0 1.643.565 1.643 1.652v10.01l-4.906-4.49c-.44-.34-.821-.564-1.344-.564-.498 0-.888.182-1.303.556l-3.81 3.395-1.594-1.486c-.349-.324-.698-.498-1.13-.498-.423 0-.73.174-1.078.49l-2.864 2.68zm5.379 5.23c1.07 0 1.95-.88 1.95-1.96 0-1.07-.88-1.959-1.95-1.959-1.08 0-1.96.889-1.96 1.96 0 1.079.88 1.958 1.96 1.958"
  })));
};
export default SvgPicture;